// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"605ed3ab","738":"bcce6d80","741":"1a0dab18"}[chunkId] + ".chunk.css";
};